module.exports = __webpack_public_path__ + "static/btn.e250326e.png";